import { gql } from "@apollo/client";

export const GET_RESTAURANTS = gql`
  query GetRestaurants(
    $country: String!
    $prefectures: [String!]
    $limit: Int!
    $offset: Int!
  ) {
    restaurants(
      country: $country
      prefectures: $prefectures
      limit: $limit
      offset: $offset
    ) {
      _id
      name
      description
      prefecture
      location
      imgUrl
    }
  }
`;

export const GET_PREFECTURES = gql`
  query GetPrefectures($country: String!) {
    getRestaurantPrefectures(country: $country)
  }
`;
